/* eslint-disable no-unused-vars */
import dynamic from 'next/dynamic'
import cn from 'classnames'
import Icon from './Icon'
import s from './Header.module.scss'

const DynamicButton = dynamic(() => import('@/components/newButton/Button'))
const Modal = dynamic(() => import('./ButtonModal'))

type UserActionsProps = {
  userData: any
  unreadApplications: boolean
  isMounted: boolean
  showMenu: boolean
  showLoginModal: boolean
  toggleMenu: () => void
  setLoginModal: (value: boolean) => void
}

export default function UserActions({
  userData,
  unreadApplications,
  isMounted,
  showMenu,
  showLoginModal,
  toggleMenu,
  setLoginModal,
}: UserActionsProps) {
  if (userData && isMounted) {
    return (
      <div className={s.keypad}>
        {/* Customer Keypad */}
        {userData.type === 'Customer' && (
          <>
            <Icon href="/customer/favourites" type="fav" />
            <Icon
              href="/customer/applications"
              type={unreadApplications ? 'appNot' : 'application'}
            />
          </>
        )}

        {/* Breeder Keypad */}
        {userData.type === 'Breeder' && (
          <>
            <Icon href="/breeder/pets" type="pet" />
            <Icon href="/breeder/applications/requests" type="application" />
          </>
        )}

        {/* Profile Toggler */}
        <div className={s.profile} onClick={toggleMenu}>
          <div className={cn(s.drop, showMenu ? s.up : s.down)} />
          <div
            className={s.closeArea}
            style={{ display: showMenu ? 'block' : 'none' }}
          />
        </div>
      </div>
    )
  }

  // Not Logged In
  return (
    <div className={s.buttons}>
      <div className={s.buttonContainer}>
        <DynamicButton
          title="Login"
          theme={['black-login', 'extra-short']}
          onClick={() => setLoginModal(true)}
        />

        {showLoginModal && (
          <Modal type="Login" onOutsideClick={() => setLoginModal(false)} />
        )}
      </div>
    </div>
  )
}
